if (!customElements.get('country-popup')) {
  class CountryPopup extends HTMLElement {
    constructor() {
      super();
    }

    open() {
      this.classList.add('is-visible');
    }

    close() {
      this.classList.remove('is-visible');
    }
    
    connectedCallback() {
      this.querySelectorAll('[data-close]').forEach(el => el.addEventListener('click', () => this.close()));
      document.querySelectorAll('[data-country-popup]').forEach(el => {
        el.addEventListener('click', () => this.open());
        el.style.cursor = 'pointer';
        el.querySelectorAll('div,span').forEach(child => child.style.pointerEvents = 'none');
      });
    }
  }
  customElements.define('country-popup', CountryPopup);
}